import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import style from "./Resiger.scss";
import globalStyle from '@/styles/Global.scss'
import MButton from "@/components/atom/MButton";
import React from "react";

const RegisterDone = (props) => {
  const history = useHistory()

  const goBack = () => {
    history.push('/')
  }

  return (
    <>
      <RegisterLayout>
        <div className={style.container}>
          <div className={globalStyle.attribute}>
            <h3>ご登録確認</h3>
          </div>
          <div className={globalStyle.attribute}>
            登録受け付けメールを送信しました。<br/>
            本登録を行うには登録完了メールの内容にしたがって操作をしてください。<br/>
            メールが届かない場合は、再度登録操作を行ってください。<br/>
          </div>
          <div className={globalStyle.attribute}>
            <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
          </div>
        </div>
      </RegisterLayout>
    </>
  )
}

export default RegisterDone;
